import { useTranslation } from 'react-i18next';

const TrackingSection = () => {
  const { t } = useTranslation('pharmacies');

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('tracking.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('tracking.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {t('tracking.items', { returnObjects: true }).map((item: any, index: number) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`text-lg text-blue-600 ${
                  index === 0 ? 'ri-money-dollar-circle-line' :
                  index === 1 ? 'ri-shopping-cart-line' :
                  index === 2 ? 'ri-database-2-line' :
                  index === 3 ? 'ri-shield-line' :
                  index === 4 ? 'ri-exchange-line' :
                  index === 5 ? 'ri-file-list-line' :
                  index === 6 ? 'ri-building-line' :
                  'ri-file-shield-line'
                }`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrackingSection;